// NO StrictMode: in React 18 dev it double-invokes mount effects, which would dial the
// call twice and run the ported VideoState teardown mid-setup. The core was written for
// single-mount semantics and must keep them.
import ReactDOM from 'react-dom/client'
import App from './App'
import { currentLanguage } from './i18n'
import { captureAutostartMarker } from './staff/setupState'
import { captureIncomingCallLink } from './staff/incomingCallLink'
import { isStandalone } from './staff/installPrompt'
import './styles/caller-flow.css'

// Capture the ?autostart=1 launch marker (Startup-shortcut verification) BEFORE
// anything can redirect: the staff sign-on round-trip returns to a fixed redirect
// URI and would drop the query string. See staff/setupState.ts.
captureAutostartMarker()

// Same reason, same moment: a notification acted on with no window open carries the call
// in the link, and the route guard would redirect it away before any screen could read it.
captureIncomingCallLink()

// A window running in standalone display-mode is always a staff window (the
// install affordance only exists on the staff dashboard; guests never install),
// but launchers may still open the bare app root: the manifest start_url of
// installations made before it pointed at #/staff, and Startup shortcuts written
// by setup files older than v0.18.0.0. The hash router resolves a bare root to
// the invalid-code screen, so route those launches to the staff surface instead.
// Only the empty route is rewritten - deep links keep working untouched.
if (isStandalone() && ['', '#', '#/'].includes(window.location.hash)) {
  window.history.replaceState(
    null,
    '',
    `${window.location.pathname}${window.location.search}#/staff`
  )
}

// index.html ships lang="en"; reflect the language this window actually resolved
// to at launch (see src/i18n/index.ts) for assistive tech and browser translation.
document.documentElement.lang = currentLanguage

ReactDOM.createRoot(document.getElementById('root')!).render(<App />)
